import { render, staticRenderFns } from "./VInfoCard.vue?vue&type=template&id=1deec998&"
import script from "./VInfoCard.vue?vue&type=script&lang=js&"
export * from "./VInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports